<template>
  <div class="csm-teach">
    <!--
    <el-card shadow="never">
      <div style="margin: 6px; font-size: 20px">课程概况</div>

      <el-row style="margin-top: 20px">
        <el-col :span="12"
          ><div>
            <div style="width: 100%; height: 300px" id="myChart"></div></div
        ></el-col>
        <el-col :span="12"
          ><div>
            <div style="width: 100%; height: 300px" id="myChart1"></div></div
        ></el-col>
      </el-row>
    </el-card>
-->
    <el-card shadow="never" style="margin-top: 10px">
      <div style="margin: 6px; font-size: 20px">课程评价</div>

      <el-form
        ref="ruleForm"
        :inline="true"
        :model="form2"
        class="form-style"
        size="mini"
      >
        <el-form-item label="科目" prop="subjectId">
          <el-select
            v-model="form2.subjectId"
            filterable
            @change="getCurriculumList"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subject_list"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程体系" prop="curriculum_id">
          <el-select
            v-model="form2.curriculum_id"
            filterable
            @change="adminGetLessonFeedbackCountInfo"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) of curriculum_list"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="form2.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            @change="adminGetLessonFeedbackCountInfo"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="adminGetLessonFeedbackCountInfo" type="primary"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <el-row>
        <el-col :span="24"
          ><div>
            <div style="width: 100%; height: 300px" id="myChart2"></div></div
        ></el-col>
      </el-row>
    </el-card>

    <el-card shadow="never" style="margin-top: 10px">
      <div style="margin: 6px; font-size: 20px">舆情监控</div>

      <div class="table-style">
        <el-form
          ref="ruleForm"
          :inline="true"
          :model="form"
          class="form-style"
          size="mini"
        >
          <el-form-item label="学校名称">
            <el-input
              placeholder="请输入学校名称"
              v-model="form2.schoolName"
              clearable
              style="width: 250px"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="科目" prop="subject_id">
            <el-select
              v-model="form.subjectId"
              filterable
              @change="adminGetLessonFeedbackList"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subject_list"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型" prop="is_satisfied">
            <el-select
              v-model="form.is_satisfied"
              style="width: 150px"
              @change="adminGetLessonFeedbackList"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="满意" value="1"></el-option>
              <el-option label="不满意" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-date-picker
              v-model="form.date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              @change="adminGetLessonFeedbackList"
              placement="bottom-start"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button @click="search3" type="primary">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="ctab"
          size="mini"
          :data="lessonFeedBackList"
          :header-cell-style="{ background: 'white' }"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (page_no - 1) * 20 }}
            </template>
          </el-table-column>

          <el-table-column label="反馈结果" width="100">
            <template slot-scope="scope">
              <span style="color: green" v-if="scope.row.is_satisfied"
                >满意</span
              >
              <span style="color: red" v-else>不满意</span>
            </template>
          </el-table-column>

          <el-table-column label="反馈时间" width="200" prop="created_time">
          </el-table-column>

          <el-table-column
            label="回访内容"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.replay_comment }}</span>
            </template>
          </el-table-column>
          <!--
          <el-table-column label="是否回访">
            <template slot-scope="scope">
              <span v-if="scope.row.is_replay">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
-->
          <el-table-column
            width="100"
            prop="subjectName"
            label="科目"
          ></el-table-column>

          <el-table-column
            width="200"
            prop="curriculumTitle"
            label="课程体系"
          ></el-table-column>

          <el-table-column
            width="150"
            prop="lessonTitle"
            label="讲次名称"
          ></el-table-column>

          <el-table-column
            width="150"
            prop="schoolName"
            label="校区名称"
          ></el-table-column>

          <el-table-column width="150" prop="userRealName" label="上课老师">
          </el-table-column>

          <el-table-column width="150" prop="username" label="平台账号">
          </el-table-column>

          <el-table-column width="150" prop="userPhoneNum" label="联系电话">
          </el-table-column>
          <!--
          <el-table-column label="原因" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.feed_back_comment }}</span>
            </template>
          </el-table-column>
-->

          <el-table-column label="回访时间" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.replay_date }}</span>
            </template>
          </el-table-column>

          <el-table-column label="回访人">
            <template slot-scope="scope">
              <span>{{ scope.row.link_man_real_name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            fixed="right"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="adminUpdateLessonFeedbackReplay(scope.row)"
                >录入回访信息</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 20px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="page_size"
            layout="total,prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" style="margin-top: 10px">
      <div style="margin: 6px; font-size: 20px">教学计划</div>

      <div class="table-style">
        <el-form
          ref="ruleForm"
          :inline="true"
          :model="form"
          class="form-style"
          size="mini"
        >
          <el-form-item label="科目" prop="subject_id">
            <el-select
              v-model="form3.subject_id"
              filterable
              @change="adminGetTchPlanList"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subject_list"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型" prop="is_satisfied">
            <el-select
              v-model="form3.classType"
              style="width: 150px"
              @change="adminGetTchPlanList"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="试听" value="2"></el-option>
              <el-option label="常规" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-date-picker
              v-model="form3.date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              @change="adminGetTchPlanList"
              placement="bottom-start"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button @click="search2" type="primary">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          size="mini"
          :data="TeachPlanList"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column fixed="left" label="讲次名称" width="150">
            <template slot-scope="scope">
              <span style="color: #409eff; font-weight: bold" type="primary">{{
                scope.row.lessionInfo.title
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="classInfo.name"
            label="所属班级"
            width="200"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="classInfo.curriculumInfo.title"
            label="所属课程"
            width="200"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="lecturerName"
            label="上课老师"
            width="150"
          ></el-table-column>

          <el-table-column align="center" label="星期" width="150">
            <template slot-scope="scope">
              <span
                v-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    0
                "
                >周日</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    1
                "
                >周一</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    2
                "
                >周二</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    3
                "
                >周三</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    4
                "
                >周四</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    5
                "
                >周五</span
              >
              <span
                v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    6
                "
                >周六</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="上课时间" width="200">
            <template slot-scope="scope">
              <span
                >{{ scope.row.start_class_date }} -
                {{ scope.row.end_class_date.slice(10, 20) }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="campusName"
            label="所属校区"
            width="200"
          ></el-table-column>

          <el-table-column align="center" width="100" label="实到/应到">
            <template slot-scope="scope">
              <span
                >{{ scope.row.stuSignNum }} /
                {{ scope.row.stuTotalSignNum }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.classInfo.curriculum_class_type == 1">
                <span v-if="!scope.row.supplement_original_tch_plan_id">
                  常规
                </span>
                <span v-else>补课</span>
              </span>
              <span v-else-if="scope.row.classInfo.curriculum_class_type == 2"
                >试听</span
              >
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            align="center"
            width="100"
            label="状态"
          >
            <template slot-scope="scope">
              <span style="color: green" v-if="scope.row.sign_state == '1'"
                >已上课</span
              >
              <span v-else-if="scope.row.sign_state == '2'">未上课</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange1"
          :current-page="page_no1"
          :page-size="page_size1"
          layout="total, prev, pager, next, jumper"
          :total="total1"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  adminGetStuNumBySubject,
  adminGetSchoolNumBySchoolSubject,
  adminGetLessonFeedbackList,
  adminUpdateLessonFeedbackReplay,
  getSubjectList,
  adminGetLessonFeedbackCountInfo,
  adminGetTchPlanList,
} from '@/api/admin'

import { getCurriculumList } from '@/api/educational'

export default {
  name: 'csm-teach',
  components: {},
  data() {
    return {
      //客户成功中心
      SchoolList: [
        {
          name: '五格演示校区',
          username: '18722160686',
        },
        {
          name: '乐博乐博',
          username: '15522869972',
        },
        {
          name: '瓦力工厂',
          username: '1822222222',
        },
      ],
      myChart: {}, //在读学员
      myChart1: {}, //员工数
      myChart2: {}, //已用时长

      //课程评价
      ruleForm: {},
      subjectList: [],

      //数据看板
      StulistBySubject: [],
      data_x_stu: [],
      data_y_stu: [],
      //课堂反馈
      form: {
        subjectId: '',
        curriculum_id: '',
        lesson_id: '',
        is_satisfied: '',
        date: [],
      },

      form2: {
        schoolName: '',
        subjectId: '',
        curriculum_id: '',
        lesson_id: '',
        is_satisfied: '',
        date: [],
      },

      page_no: 1,
      page_size: 20,
      total: 0,
      lessonFeedBackList: [], // 反馈详情

      subject_list: [], //科目列表
      lessonFeedbackCountList: [], //课程反馈统计
      curriculum_list: [], //课程体系

      comment_data_x: [],
      comment_data_y1: [], //满意数
      comment_data_y2: [], //不满意

      TeachPlanList: [], //教学计划
      form3: {
        subject_id: '',
        classType: '',
        date: [],
      },
      page_no1: 1,
      page_size1: 20,
      total1: 0,
    }
  },
  computed: {},
  mounted() {
    if (this.$store.getters.adminToken) {
      this.getSubjectList()
      //this.adminGetStuNumBySubject();
      //this.adminGetSchoolNumBySchoolSubject();
      this.adminGetLessonFeedbackList()
    }
  },
  methods: {
    //根据科目权限查询校区人数
    adminGetStuNumBySubject() {
      adminGetStuNumBySubject().then((res) => {
        console.log('根据科目统计学员')
        console.log(res)
        this.StulistBySubject = res.schoolNumList

        this.data_x_stu = []
        this.data_y_stu = []

        for (let k = 0; k < this.StulistBySubject.length; k++) {
          this.data_x_stu.push(this.StulistBySubject[k].subjectInfo.name)
          this.data_y_stu.push(this.StulistBySubject[k].count)
        }

        console.log(this.data_x_stu)
        console.log(this.data_y_stu)

        this.$nextTick(function() {
          this.drawLine()
          //this.getStaff();
          //this.getTime();
        })
      })
    },

    //根据科目权限查询校区人数
    adminGetSchoolNumBySchoolSubject() {
      adminGetSchoolNumBySchoolSubject().then((res) => {
        console.log('根据科目统计学校')
        console.log(res)
        this.SchoollistBySubject = res.schoolNumList

        this.data_x_school = []
        this.data_y_school = []

        for (let k = 0; k < this.SchoollistBySubject.length; k++) {
          this.data_x_school.push(this.SchoollistBySubject[k].subjectInfo.name)
          this.data_y_school.push(this.SchoollistBySubject[k].count)
        }

        console.log(this.data_x_school)
        console.log(this.data_y_school)

        this.$nextTick(function() {
          this.getStaff()
          // this.getTime();
        })
      })
    },

    //课堂反馈列表
    adminGetLessonFeedbackList() {
      console.log('this.form.subjectId')
      console.log(this.form.subjectId)

      adminGetLessonFeedbackList({
        schoolName: this.form2.schoolName,

        subjectId: this.form.subjectId,
        curriculum_id: this.form.curriculum_id,
        lesson_id: this.form.lesson_id,
        is_satisfied: this.form.is_satisfied,
        start_date: this.form.date ? this.form.date[0] : '',
        end_date: this.form.date ? this.form.date[1] : '',
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('课堂反馈详情列表')
        console.log(res)
        this.lessonFeedBackList = res.lessonFeedBackList
        this.total = res.total
      })
    },

    //管理员更新回访信息
    adminUpdateLessonFeedbackReplay(row) {
      this.$prompt('请录入客户反馈内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          if (value) {
            adminUpdateLessonFeedbackReplay({
              lesson_feedback_id: row.id,
              is_replay: '1',
              replay_comment: value,
            }).then((res) => {
              console.log('课堂反馈回访')
              console.log(res)
              if (res.is_update) {
                this.$message.success('录入成功')
                this.adminGetLessonFeedbackList()
              }
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消录入',
          })
        })
    },

    //课程满意度统计
    adminGetLessonFeedbackCountInfo() {
      adminGetLessonFeedbackCountInfo({
        subjectId: this.form2.subjectId,
        curriculum_id: this.form2.curriculum_id,
        lesson_id: this.form2.lesson_id,
        start_date: this.form2.date ? this.form2.date[0] : '',
        end_date: this.form2.date ? this.form2.date[1] : '',
      }).then((res) => {
        console.log('课程满意度统计')
        console.log(res)

        this.lessonFeedbackCountList = res.lessonList

        this.comment_data_x = []
        this.comment_data_y1 = []
        this.comment_data_y2 = []

        for (let k = 0; k < this.lessonFeedbackCountList.length; k++) {
          this.comment_data_x.push(this.lessonFeedbackCountList[k].title)
          this.comment_data_y1.push(
            this.lessonFeedbackCountList[k].satisfied_count
          )
          this.comment_data_y2.push(
            this.lessonFeedbackCountList[k].not_satisfied_count
          )
        }

        this.$nextTick(function() {
          this.getTime()
        })
      })
    },

    // 获取课程体系
    getCurriculumList() {
      this.form2.curriculum_id = ''

      getCurriculumList(
        {
          subject_id: this.form2.subjectId,
          teaching_type: '',
          curriculum_type: '',
          page_no: 1,
          page_size: 200,
        },
        true
      ).then((res) => {
        console.log('课程体系')
        console.log(res)
        this.curriculum_list = res.curriculum_list

        this.form2.curriculum_id = this.curriculum_list[0].id

        this.adminGetLessonFeedbackCountInfo()
      })
    },

    //平台教学计划
    adminGetTchPlanList() {
      console.log('查询平台教学计划')
      console.log(this.form3)

      if (!this.form3.date) {
        this.$message.warning('请选择时间范围')
        return
      }

      adminGetTchPlanList({
        subject_id: this.form3.subject_id,
        classType: this.form3.classType,
        start_date: this.form3.date ? this.form3.date[0] : '',
        end_date: this.form3.date ? this.form3.date[1] : '',
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('平台教学计划列表')
        console.log(res)
        this.TeachPlanList = res.teachingPlan
        this.total1 = res.total
      })
    },

    search2() {
      this.page_no1 = 1
      this.adminGetTchPlanList()
    },

    search3() {
      this.page_no = 1
      this.adminGetLessonFeedbackList()
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.adminGetLessonFeedbackList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.adminGetTchPlanList()
    },

    getSubjectList() {
      getSubjectList(
        {
          subject_state: '1',
          page_no: 1,
          page_size: 100,
        },
        true
      ).then((res) => {
        console.log('平台科目')
        console.log(res)
        this.subject_list = res.subject_list

        this.form2.subjectId = this.subject_list[0].id
        this.getCurriculumList()
      })
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      this.myChart.setOption({
        title: { text: '学员分布' },
        tooltip: {},
        xAxis: {
          data: this.data_x_stu,
        },
        yAxis: {},
        series: [
          {
            name: '学员数',
            type: 'bar',
            data: this.data_y_stu,
          },
        ],
      })

      var that = this

      this.myChart.on('click', function(params) {
        console.log(params.name)
        that.$message.success(params.name)
      })
    },

    getStaff() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart1 = this.$echarts.init(document.getElementById('myChart1'))
      // 绘制图表
      this.myChart1.setOption({
        title: { text: '学校分布' },
        tooltip: {},
        xAxis: {
          data: this.data_x_school,
        },
        yAxis: {},
        series: [
          {
            name: '校区数',
            type: 'bar',
            data: this.data_y_school,
          },
        ],
      })

      var that = this

      this.myChart1.on('click', function(params) {
        console.log(params.name)
        that.$message.success(params.name)
      })
    },

    getTime() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart2 = this.$echarts.init(document.getElementById('myChart2'))
      // 绘制图表
      this.myChart2.setOption({
        title: { text: '' },
        tooltip: {},
        color: ['green', 'red'],
        xAxis: {
          data: this.comment_data_x,
        },
        yAxis: {},
        series: [
          {
            name: '满意',
            type: 'bar',
            data: this.comment_data_y2,
          },
          {
            name: '不满意',
            type: 'bar',
            data: this.comment_data_y1,
          },
        ],
      })

      var that = this

      this.myChart2.on('click', function(params) {
        console.log(params.name)
        that.$message.success(params.name)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.csm-teach {
  height: 100%;
  margin: 10px;
  .form-style {
    margin-left: 10px;
  }
}
</style>
